"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const static_html_js_1 = require("lit/static-html.js");
const text_styles_1 = require("@/components/common/text/text.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
let Text = class Text extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.as = 'span';
        this.size = '14';
        this.weight = 'medium';
        this.color = 'inherit';
        this.centered = false;
        this.maxLines = '';
    }
    render() {
        const tag = (0, static_html_js_1.unsafeStatic)(this.as);
        // eslint-disable-next-line lit/binding-positions, lit/no-invalid-html -- lit/static-html의 태그 자리 바인딩이라 정상이다. 규칙이 일반 html 태그만 가정해 오탐한다.
        return (0, static_html_js_1.html) `<${tag}><slot></slot></${tag}>`;
    }
};
Text.styles = [shared_styles_1.resetStyles, text_styles_1.textStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Text.prototype, "as", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Text.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Text.prototype, "weight", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Text.prototype, "color", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], Text.prototype, "centered", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'max-lines', reflect: true })
], Text.prototype, "maxLines", void 0);
Text = __decorate([
    (0, decorators_js_1.customElement)('mm-text')
], Text);
exports.Text = Text;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInRleHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQWdDO0FBQ2hDLHFEQUEyRDtBQUMzRCx1REFBdUQ7QUFFdkQsc0VBTTZDO0FBQzdDLCtEQUF5RDtBQUtsRCxJQUFNLElBQUksR0FBVixNQUFNLElBQUssU0FBUSxnQkFBVTtJQUE3Qjs7UUFFdUIsT0FBRSxHQUFXLE1BQU0sQ0FBQTtRQUNKLFNBQUksR0FBYSxJQUFJLENBQUE7UUFDckIsV0FBTSxHQUFlLFFBQVEsQ0FBQTtRQUM3QixVQUFLLEdBQWMsU0FBUyxDQUFBO1FBQzNCLGFBQVEsR0FBRyxLQUFLLENBQUE7UUFDTyxhQUFRLEdBQWlCLEVBQUUsQ0FBQTtJQU9oRyxDQUFDO0lBTEMsTUFBTTtRQUNKLE1BQU0sR0FBRyxHQUFHLElBQUEsNkJBQVksRUFBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUE7UUFDakMsc0lBQXNJO1FBQ3RJLE9BQU8sSUFBQSxxQkFBSSxFQUFBLElBQUksR0FBRyxtQkFBbUIsR0FBRyxHQUFHLENBQUE7SUFDN0MsQ0FBQzs7QUFaTSxXQUFNLEdBQUcsQ0FBQywyQkFBVyxFQUFFLHdCQUFVLENBQUMsQ0FBQTtBQUNiO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztnQ0FBb0I7QUFDSjtJQUExQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQztrQ0FBc0I7QUFDckI7SUFBMUMsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7b0NBQThCO0FBQzdCO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO21DQUE2QjtBQUMzQjtJQUEzQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQztzQ0FBaUI7QUFDTztJQUFsRSxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxXQUFXLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO3NDQUE0QjtBQVBuRixJQUFJO0lBRGhCLElBQUEsNkJBQWEsRUFBQyxTQUFTLENBQUM7R0FDWixJQUFJLENBY2hCO0FBZFksb0JBQUkifQ==